import { cn } from '@repo/tailwind-config/tailwind.functions'

import useLanguageTest from '../../../../views/client-personal-space/informations/context/use-language-test'

const LanguageTestTimer = () => {
  const { timer } = useLanguageTest()

  // Less than 5 minutes left
  const lessThan5Minutes = timer.remainingTimeMs < 5 * 60 * 1000

  return (
    <div
      className={cn(
        'font-mono text-lg font-semibold text-primary',
        lessThan5Minutes && 'text-red'
      )}
    >
      {timer.formattedTime}
    </div>
  )
}

export default LanguageTestTimer
